/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "../../styles.css";
import { GestaoDeCronicosStepsEnum } from "../../../../../interfaces/enum/GestaoDeCronicosEnum";
import DefaultText from "../../../../../components/Accessibility/DefaultText";
import DefaultButton from "../../../../../components/Accessibility/DefaultButton";
import DefaultTable from "../../../../../components/Accessibility/DefaultTable";
import TableRegular from "../../../../../components/Accessibility/DefaultTable/TableRegular";
import TableBold from "../../../../../components/Accessibility/DefaultTable/TableBold";
import { FormatStringToNumber } from "../../../../../utils/FormatStringToNumber";
import { useGestaoDeCronicosCaptacao } from "../../context/CaptacaoContext";
import LoadingApp from "../../../../../components/LoadingApp";

export const ResultadoIMC = () => {
  const [getIndex, setGetIndex] = useState(-1);
  const [resultIMC, setResultIMC] = useState<string>("");
  const { loading, responseQuestionnaire, respIMC, handleChangeStep } =
  useGestaoDeCronicosCaptacao();
  const dataIMC = responseQuestionnaire
    ? responseQuestionnaire.listaTabelaImc.map((item) => [
        <TableBold text={item.texto} />,
        <TableRegular text={item.classificacao} />,
      ])
    : [];

  const classificarIMC = (vlrIMC: string) => {
    const valorIMC = FormatStringToNumber(vlrIMC);

    if (!responseQuestionnaire?.listaTabelaImc) {
      return { classificacao: "Indeterminado", index: -1 };
    }

    const index = responseQuestionnaire.listaTabelaImc.findIndex(
      (range) =>
        (range.valorInicial >= 40 && valorIMC >= range.valorInicial) ||
        (valorIMC >= range.valorInicial && valorIMC < range.valorFinal)
    );

    if (index !== -1) {
      return { ...responseQuestionnaire.listaTabelaImc[index], index };
    }

    return { classificacao: "Indeterminado", index: -1 };
  };

  useEffect(() => {
    if (respIMC?.vlrIMC) {
      const dataIMC = classificarIMC(respIMC?.vlrIMC);
      setResultIMC(dataIMC.classificacao);
      setGetIndex(dataIMC.index);
    }
  }, []);

  return (
    <div className="content-container">
      <LoadingApp showLoading={loading} />

      {!loading && (
        <>
          <DefaultText
            style={{ margin: "15px 0px 15px 0px " }}
            text={
              "Com base na sua altura e peso, veja o resultado do seu índice de Massa Corporal-IMC:”"
            }
          />
          <div className="imc-result-container">
            <div>
              <div className="imc-result-weight">{respIMC?.vlrIMC}</div>
              <div className="imc-result-text">{resultIMC}</div>
            </div>
          </div>
          <DefaultText
            style={{ margin: "15px 0px 15px 0px " }}
            text={"Confira na tabela abaixo a sua classificação segundo a OMS:"}
          />
          <DefaultTable
            data={dataIMC}
            headers={["IMC", "Dados pessoais"]}
            columnWidths={["50%", "50%"]}
            rowStyleCondition={(rowIndex) => getIndex === rowIndex}
          />
          <DefaultButton
            style={{ margin: "30px 0px 30px 0px " }}
            className="button-questionnaire-detail"
            text="Continuar"
            onClick={() => {
              handleChangeStep(GestaoDeCronicosStepsEnum.questionarioQuestoes);
            }}
          />
        </>
      )}
    </div>
  );
};
